//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { venues_list } from '@/apis/stadium';
import { service_add } from '@/apis/product';

export default {
    data() {
        return {
            spinning: false,
            gymnasiums: [],
            submitData: '',
            parseResult: '',
            form: {
                venueCode: [],
                name: '',
                typeCode: '',
                status: '1'
            },
            rules: {
                venueCode: [{ required: true, message: '請選擇所屬場館！' }],
                name: [{ required: true, message: '請輸入產品名稱！' }],
                typeCode: [{ required: true, message: '請選擇服務類型！' }],
                status: [{ required: true, message: '請選擇狀態！' }],
            },
            labelCol: { style: { width: '150px', }, },
            wrapperCol: { span: 14, },
        }
    },
    async mounted() {
        await this.loadVenues();
    },
    methods: {
        async loadVenues() {
            try {
                const data = { venueCode: '', venueName: '', sportTypeCode: '', status: '1', areaCode: '', pageSize: 999, pageNumber: 1 };
                const res = await venues_list(data) || {};
                if (res.code == 0) {
                    this.gymnasiums = res.data.records;
                    console.log('[TEST] 場館列表:', this.gymnasiums);
                }
            } catch (error) {
                console.error('[TEST] 加載場館失敗:', error);
            }
        },
        async onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (!valid) return;

                this.spinning = true;
                try {
                    const submitForm = { ...this.form };
                    submitForm.venueCode = JSON.stringify(submitForm.venueCode);
                    submitForm.facilities = JSON.stringify([]);
                    submitForm.activityVideos = JSON.stringify(['']);
                    submitForm.activityImages = JSON.stringify(['']);
                    submitForm.unlimitedQuota = 10;
                    submitForm.genderRestrict = 0;
                    submitForm.maleQuota = '';
                    submitForm.femaleQuota = '';
                    submitForm.maxParticipants = 10;
                    submitForm.startTime = '2026-07-01';
                    submitForm.endTime = '2026-12-31';
                    submitForm.organizer = '測試單位';
                    submitForm.syllabus = '測試大綱';
                    submitForm.description = '測試說明';
                    submitForm.reminder = '測試註意事項';
                    submitForm.mainImage = 'https://example.com/image.jpg';
                    submitForm.sportType = '1';
                    submitForm.ticketType = '1';
                    submitForm.points = '1';
                    submitForm.isPopular = false;
                    submitForm.isFeatured = false;

                    this.submitData = JSON.stringify(submitForm, null, 2);
                    console.log('[TEST] 提交數據:', submitForm);

                    const res = await service_add(submitForm);
                    console.log('[TEST] 提交結果:', res);

                    if (res.code == 0) {
                        this.$message.success('提交成功！');
                    } else {
                        this.$message.error(res.msg || '提交失敗');
                    }
                } catch (error) {
                    console.error('[TEST] 提交錯誤:', error);
                    this.$message.error(error.message);
                } finally {
                    this.spinning = false;
                }
            });
        },
        onTestParse() {
            const testCases = [
                '["V001","V002","V003"]',
                '"V001"',
                'V001',
                '[]',
                '',
                null,
            ];

            const results = testCases.map((input, index) => {
                let parsed;
                try {
                    if (typeof input === 'string') {
                        parsed = JSON.parse(input);
                    } else {
                        parsed = input;
                    }
                } catch (e) {
                    parsed = input ? [input] : [];
                }
                const result = Array.isArray(parsed) ? parsed : (parsed ? [parsed] : []);
                return {
                    index: index + 1,
                    input: JSON.stringify(input),
                    parsed: result,
                    length: result.length
                };
            });

            this.parseResult = JSON.stringify(results, null, 2);
            console.log('[TEST] 解析測試結果:', results);
            this.$message.success('解析測試完成，請查看控制臺');
        }
    }
}
